import "./App.scss";
import { useState, useEffect } from "react";
import InputModals from "./components/InputModals";
import AfterModal from "./components/AfterModal";
import ModalPolicy from "./components/ModalPolicy";
import axios from "axios";

function App() {
  const [showInputModal, setShowInputModal] = useState(false);
  const [showAfterModal, setShowAfterModal] = useState(false);
  const [showModalPolicy, setShowModalPolicy] = useState(false);
  const [modalText, setModalText] = useState("Please try again later");
  const [modalTitle, setModalTitle] = useState("Please try again later");
  const [connectionError, setConnectionError] = useState(false);

  const sendData = async (name, phone, email, player, fitSize) => {
    try {
      if (name && phone && email && player && fitSize) {
        const response = await axios.post("https://batery.ai:3000/submit", {
          name,
          phone,
          email,
          player,
          fitSize,
        });

        if (response.data.status === 200) {
          if (response.data.message === `User processed with action: not first attempt`) {
            setModalText(`You can participate only once`);
            setModalTitle(`Thank you for your participation!`);
            setShowAfterModal(true);
          } else {
            setModalText(
              `Your application has been successfully approved! We are waiting for you on December 22! Don't forget your previous seasons T-shirt!`
            );
            setModalTitle(`Thank you for your participation!`);
            setShowAfterModal(true);
          }
          // Handle success
          // console.log("Data sent successfully");
        } else {
          // Handle error from server
          setModalTitle(`An error occured!`);
          setModalText(response.data.message);
          setShowAfterModal(true);
        }
      } else {
        setModalTitle(`An error occured!`);
        setModalText(`Please fill all the fields`);
        setShowAfterModal(true);
      }
    } catch (err) {
      setModalTitle(`An error occured!`);
      setModalText(`Please try again later`);
      setShowAfterModal(true);
    }
  };

  const sendAnalytics = (type) => {
    try {
      axios
        .get(`https://batery.ai:3000/recordAnalytics?type=${type}`)
        .then((data) => {
          // console.log(`Connection successsfull`);
        })
        .catch(() => {
          setConnectionError(true);
        });
    } catch {
      setConnectionError(true);
    }
  };

  useEffect(() => {
    sendAnalytics(`Page loaded`);
    return () => {
      console.log("Thank you for participation");
    };
  }, []);

  return (
    <div className="wrapper">
      {showInputModal && (
        <InputModals sendData={sendData} showInput={setShowInputModal} showModalPolicy={setShowModalPolicy} />
      )}

      {showAfterModal && <AfterModal showModal={setShowAfterModal} modalTitle={modalTitle} modalText={modalText} />}

      {showModalPolicy && <ModalPolicy showModal={setShowModalPolicy} />}

      <div className="container">
        <div className="logoContainer">
          <img src="/logo.png" alt="Loading..." />
        </div>

        <div className="contentContainer">
          <div className="textSide">
            <div className="titleBlock">
              <img src="/chevron.svg" alt="" />

              <h2>Update your jersey!</h2>
            </div>

            <p>
              Bring any <span>old East Bengal jersey</span> from last seasons on <span>home game 22nd December</span> in
              Batery Zone and <span>get a new one with an autograph of your favorite player!</span>
            </p>

            <div className="buttonBlock">
              <button
                onClick={() => {
                  sendAnalytics(`Button Pressed`);
                  setShowInputModal(!showInputModal);
                }}
              >
                I want new jersey
              </button>
            </div>
          </div>

          <div className="jerseySide">
            <img src="/jersey.png" alt="Loading..." />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
